<template>
  <router-view></router-view>
</template>

<script>
export default { name: 'app' }
</script>

<style>
/* ---- Inter font ---- */
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

/* ---- Theme variables (KYC mockup palette) ---- */
:root {
  --c-bg:        #F0F2F5;
  --c-surface:   #FFFFFF;
  --c-border:    #EAECF0;
  --c-divider:   #F0F2F5;
  --c-soft:      #F9FAFB;
  --c-text:      #0A0A0A;
  --c-text-2:    #374151;
  --c-text-3:    #6B7280;
  --c-muted:     #9CA3AF;
  --c-placeholder: #C0C4CC;
  --c-accent:    #16A37F;
  --c-accent-2:  #138C6C;
  --c-accent-bg: #EDFAF5;
  --c-accent-bg-2: #F0FBF8;
  --c-accent-dark: #0D7A5F;
  --c-danger:    #DC2626;
  --c-danger-bg: #FEF2F2;
  --c-warning:   #D97706;
  --c-warning-bg: #FFFBEB;
  --c-success:   #065F46;
  --c-success-bg: #ECFDF5;

  --r-sm: 6px;
  --r-md: 8px;
  --r-lg: 10px;
  --r-xl: 12px;

  --shadow-1: 0 1px 3px rgba(0,0,0,0.04);
  --shadow-2: 0 4px 16px rgba(0,0,0,0.06);
  --shadow-3: 0 12px 40px rgba(0,0,0,0.12);

  --nav-h: 60px;
  --sidebar-w: 240px;
}

html, body, #app {
  font-family: 'Inter', system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  background: var(--c-bg);
  color: var(--c-text);
  font-size: 14px;
}

body { margin: 0; }

/* Soften BootstrapVue defaults to fit the new theme */
.btn-primary { background: var(--c-accent) !important; border-color: var(--c-accent) !important; }
.btn-primary:hover { background: var(--c-accent-2) !important; border-color: var(--c-accent-2) !important; }

a { color: var(--c-accent); }
a:hover { color: var(--c-accent-2); }
</style>
